import React, { useEffect, useState } from 'react';
import './Event.css';


export const EventFlyer = (props) => {
    const [imagePath, setImagePath] = useState('');

    useEffect(() => {
        const fetchImage = async () => {
            const response = await import(`../res/${props.match.params.id}.png`);
            setImagePath(response.default);
        }

        fetchImage();
    }, [props])

    return (
        <div>
            <img src={imagePath} alt="Event Flyer" className="responsive" />
       </div>
    );

}
